export interface KnowledgeQuestion extends Record<string, unknown> {
  questionType: number;
  questionTitle: string;
  questionOptionList: unknown[];
  subTopicList: KnowledgeQuestion[];
  userAnswer: string | string[];
}

/** 兼容旧知识点的选项字符串、组合题子题和当前试题展示组件的数据格式。 */
export function normalizeKnowledgeQuestion(
  item: Record<string, unknown>
): KnowledgeQuestion {
  const questionType = Number(item.questionType);
  let options: unknown = item.questionOptionList ?? item.questionOption;
  if (typeof options === "string") {
    try {
      options = JSON.parse(options);
    } catch {
      options = [];
    }
  }
  const children = item.subTopicList ?? item.childSubject;
  return {
    ...item,
    questionType,
    questionTitle: String(item.questionTitle ?? item.name ?? ""),
    questionOptionList: Array.isArray(options)
      ? options
      : options && typeof options === "object"
      ? Object.values(options)
      : [],
    subTopicList: Array.isArray(children)
      ? children
          .filter(
            (child): child is Record<string, unknown> =>
              !!child && typeof child === "object"
          )
          .map(normalizeKnowledgeQuestion)
      : [],
    userAnswer: [1, 6].includes(questionType) ? [] : "",
  };
}
